import { TimeBoxContainer } from "@components/timeBox/TimeBox";
import { PatientCards } from "./PatientCards";
import { AssignFormsStepper } from "@components/stepper/AssignFormsStepper";
import { useGetInOfficeEventsQuery } from "@services/formAssignments";
import {
  sessionStorageService,
  localStorageService,
} from "@utils/storageService/StorageService";
import type { IInOfficeEvent } from "../../../types/formAssignments/IInOfficeEvent";
import { FormAssignmentsPage } from "../FormAssignmentsWrapper";
import PageLayout from "@components/pageLayout/PageLayout";
import { useGetFeatureFlag } from "@hooks/useGetFeatureFlag";
import { EFeatureFlags } from "../../../enums/EFeatureFlags";

// Pagintaion was setup for Leap in office tab, but there was an error with it and
// the pageSize was hardcoded to 500. See https://github.com/practicaldentalsolutions/yapi.webapp.dentistry/pull/1572
// No one would ever scroll that much, so pagintation is effectively disabled in leap.
// Duplicating that same logic here. Both leap and here should be fixed at some point.
const PAGINATION_SEARCH_PARAMS = {
  pageIndex: 1,
  pageSize: 500,
};

const PATIENTS_REFETCH_INTERVAL_IN_MS = 30000;

type Props = {
  selectedEvent: IInOfficeEvent | null;
  setSelectedEvent: (event: IInOfficeEvent) => void;
  setPage: (page: FormAssignmentsPage) => void;
};

const PatientListPage = ({
  selectedEvent,
  setSelectedEvent,
  setPage,
}: Props) => {
  const userSession = sessionStorageService.get("fastr_token");
  const practiceGuid = localStorageService.get("fastr_practiceId");

  const { isEnabled: isFamilyFeatureEnabled } = useGetFeatureFlag(
    EFeatureFlags.FastrAppFamilyEnabled
  );

  const { data: inOfficeEventsApiResponse } = useGetInOfficeEventsQuery(
    PAGINATION_SEARCH_PARAMS,
    {
      refetchOnMountOrArgChange: true,
      pollingInterval: PATIENTS_REFETCH_INTERVAL_IN_MS,
      skip: !practiceGuid && !userSession,
    }
  );

  return (
    <PageLayout
      primaryButtonConfig={{
        label: "Next",
        onClick: () => setPage("assignForms"),
        disabled: selectedEvent == null,
      }}
    >
      <AssignFormsStepper
        title="Assign Forms"
        stepOne="Choose patient"
        stepTwo={
          isFamilyFeatureEnabled ? "Select appt and forms" : "Select forms"
        }
        currentStepNumber={1}
      />
      <TimeBoxContainer title="Today's Patients" />
      <PatientCards
        events={inOfficeEventsApiResponse?.data || []}
        selectedEvent={selectedEvent}
        setSelectedEvent={setSelectedEvent}
      />
    </PageLayout>
  );
};

export default PatientListPage;
